import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[forceLowercase]'
})
export class ForceLowercaseDirective {
  @Input()
  forceLowercase: {
    currentValue?: string;
    dotSeperator: boolean;
  } = {
    dotSeperator: false
  };

  @HostListener('input', ['$event'])
  onInputChange(event: InputEventWrapper): void {
    const { target } = event;
    const { value } = target;

    const { dotSeperator, currentValue } = this.forceLowercase;

    (event.target as HTMLInputElement).value = value.toLowerCase();

    if (!dotSeperator) return;

    const letters = `${value
      .split('')
      .filter(letter => letter !== '.')
      .join('.')
      .toLowerCase()}${value.split('').length ? '.' : ''}`;

    (event.target as HTMLInputElement).value = currentValue === letters ? value : letters;
  }
}
